/** @description Формирование массива слайдов из полученных нод и ключа равного порядковому номеру слайда
 * @param {React.ReactNode[]} nodes массив нод для отображения в карусели
 * @return {TSlides[]}
 */
export function getSlides(nodes) {
  var slides = nodes.map(function (node, index) {
    return {
      node: node,
      key: "".concat(index + 1)
    };
  });
  return slides;
}